
const ComingSoon = () => {
    return (
      <div className="flex items-center justify-center h-64 m-auto">
        <p className="text-2xl font-semibold text-gray-500">Coming Soon</p>
      </div>
    );
  };
  
  export default ComingSoon; 